import { Group, Stack } from "@mantine/core"
import { getPaginationRowModel } from "@tanstack/react-table"
import { ColumnManager, DEFAULT_PAGE_SIZE, Loader } from "@tfg/ui"
import { useState } from "react"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import {
  ExportConfigurationDto,
  ExportRequestResponseDto,
  useGetExportConfigurations,
} from "~/gen/api"
import { useGetColumnManagerTranslations } from "~/hooks/table"
import { ExportConfigurationsSelect } from "~/pages/Brand/DataTransfer/Export/ExportConfigurationsSelect"
import { GenerateExportActions } from "~/pages/Brand/DataTransfer/Export/GenerateExportAction"
import { useColumns } from "~/pages/Brand/DataTransfer/Export/columns"

type Props = {
  data: ExportRequestResponseDto[]
  total: number
}

export const ExportRequestsTable: React.FC<Props> = ({ data = [] }: Props) => {
  const { data: exportConfigurationsQuery, isPending: isLoading } =
    useGetExportConfigurations()
  const columnManagerTranslations = useGetColumnManagerTranslations()
  const columns = useColumns()
  const [selectedExportConfiguration, setSelectedExportConfiguration] =
    useState<ExportConfigurationDto | undefined>(undefined)
  const [isColumnManagerOpen, setIsColumnManagerOpen] = useState(false)
  const table = useCustomReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageSize: DEFAULT_PAGE_SIZE,
      },
    },

    getPaginationRowModel: getPaginationRowModel(),
  })

  if (isLoading) return <Loader fullPage />
  return (
    <Stack>
      <Group justify="-moz-initial">
        <ExportConfigurationsSelect
          selectedExportConfiguration={selectedExportConfiguration}
          setSelectedExportConfiguration={setSelectedExportConfiguration}
          exportConfigurationsData={exportConfigurationsQuery?.data}
        />
        <GenerateExportActions
          selectedExportConfiguration={selectedExportConfiguration}
        />
        <ColumnManager
          table={table}
          translations={columnManagerTranslations}
          isOpen={isColumnManagerOpen}
          setIsOpen={setIsColumnManagerOpen}
        />
      </Group>
      <CustomTable
        table={table}
        setOpenColumnManager={setIsColumnManagerOpen}
      />
    </Stack>
  )
}
